var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VView',{staticClass:"contest-end",attrs:{"back-button-to":"/menu","header":"Sukces!"}},[_c('VText',{attrs:{"center":""}},[_vm._v("Twój wynik został zapisany!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }